import SalaryPage from './SalaryPage';

export default SalaryPage;
